import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import tokenManager from '../services/tokenManager'

/**
 * Hook to initialize the token manager with Auth0
 * This should be called once at the app level
 */
export const useTokenManager = () => {
  const { getAccessTokenSilently, logout } = useAuth0()

  useEffect(() => {
    // Initialize token manager with Auth0 hook
    tokenManager.initialize(getAccessTokenSilently)

    // Clear token on logout
    const handleLogout = () => {
      tokenManager.clearToken()
    }

    // Listen for logout events (you might need to implement this based on your logout flow)
    window.addEventListener('auth0:logout', handleLogout)

    return () => {
      window.removeEventListener('auth0:logout', handleLogout)
    }
  }, [getAccessTokenSilently])

  return {
    getToken: (options) => tokenManager.getToken(options),
    clearToken: () => tokenManager.clearToken(),
    hasValidToken: () => tokenManager.hasValidToken()
  }
}
